import { render } from "./Home.vue?vue&type=template&id=05e15c25&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=05e15c25&lang=css"

import exportComponent from "/home/schulz/philipp-schulz.dev/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__